// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Author_wrapper__r_8dq","avatar":"Author_avatar__WghfO","details":"Author_details__62geL"};